import { ChangeDetectorRef, Component, DestroyRef, inject,Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformServer } from '@angular/common';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { LoggedInUser } from '../../../../models/logged-in-user.model';
import { ApiService } from '../../../../services/api.service';
import { ToasterService } from '../../../../services/toaster.service';
import { WorkshopSuccessModalComponent } from '../workshop-success-modal/workshop-success-modal.component';
import { routes } from '../../../../constants/routes';
import { TextInputComponent } from '../../../utility/form/text-input/text-input.component';
import { TextDropdownInputComponent } from '../../../utility/form/text-dropdown-input/text-dropdown-input.component';
import { DropdownInputComponent } from '../../../utility/form/dropdown-input/dropdown-input.component';
import { TextareaInputComponent } from '../../../utility/form/textarea-input/textarea-input.component';
import { DateInputComponent } from '../../../utility/form/date-input/date-input.component';
import { SupportComponent } from '../support/support.component';
import { UNIVERSITY_FORM_CONFIG } from '../../../../constants/university-engagementform';
import { CachingService } from '../../../../services/caching.service';
import { skip,distinctUntilChanged,take, tap,  } from 'rxjs';
import {
  RegistrationWindowStatus,
  getRegistrationWindowMessage,
  getRegistrationWindowStatus,
} from '../../../../constants/registration-window.util';
import { LoaderService } from '../../../../services/loader.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-register-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    WorkshopSuccessModalComponent,
    TextInputComponent,
    DropdownInputComponent,
    TextareaInputComponent,
    DateInputComponent,
    SupportComponent
  ],
  templateUrl: './register-form.component.html',
  styleUrl: './register-form.component.scss',
})
export class RegisterFormComponent {

  applicationForm: FormGroup;
  formConfig = UNIVERSITY_FORM_CONFIG;
 private readonly destroyRef = inject(DestroyRef);
  renderRegisterFormContent = true;
  showSuccessPopup = false;
  generatedReferenceId = '';
  submittedUserEmail = '';
  userProfile: LoggedInUser['user'];
  isAuthResolved = false;
  minFromDate: Date = new Date();
  minToDate: Date = new Date();
  RegistrationWindowStatus = RegistrationWindowStatus;
  registrationWindowStatus: RegistrationWindowStatus = RegistrationWindowStatus.Open;
  registrationWindowMessage = '';
  private userToken: any;
  states = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Delhi',
    'Jammu & Kashmir',
    'Ladakh',
  ];
  institutionTypes: string[] = [
    'Central University',
    'State University',
    'Deemed University',
    'Institute of National Importance',
    // 'Private University'
  ];


  sectors = [
    'Agriculture',
    'Healthcare',
    'Environment',
    'Language',
    'Education',
    'Governance',
    'Finance',
    'Sector Agnostic',
    'Others',
  ];

  studentParticipants = [
    '1-50',
    '51-100',
    '101-200',
    '201-500',
    '500+',
  ];

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    private toasterService: ToasterService,
    private cachingService: CachingService,
    private loaderService : LoaderService,
    @Inject(PLATFORM_ID) private platformId: string,
    private cdr: ChangeDetectorRef,
  ) {
    this.applicationForm = this.fb.group({
      fullNameOfInstitution: ['', Validators.required],
      institutionType: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      institutionWebsite: ['', [Validators.required, Validators.pattern(/^https?:\/\/.*/)]],

      naacAccreditationGrade: ['', Validators.maxLength(200)],
      previousEngagementWithIndiaAI: ['', Validators.maxLength(2000)],

      // Part A: NIRF ranking, if applicable (optional)
      nirfRanking: ['', [Validators.maxLength(500)]],

      participatingDepartments: [
        '',
        [Validators.required, Validators.maxLength(1500)],
      ],

      relevantSectors: [[], Validators.required],
      otherSectorDetails: [''],
      aiDataRelevance: [
        '',
        [Validators.required, Validators.maxLength(2500)],
      ],

      selectAllReasoning: ['', Validators.maxLength(2000)],
      connectionWithExistingCoursework: ['', Validators.maxLength(2000)],

      // Part B: relevance of AIKosh sectors to participating departments
      sectorRelevanceReasoning: [
        '',
        [Validators.maxLength(200)],
      ],

      fullNameContactPerson: ['', Validators.required],
      designation: ['', Validators.required],
      department: ['', Validators.required],

      officialEmailAddress: [
        '',
        [Validators.required, Validators.email],
      ],

      phoneNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{10}$'),
        ],
      ],

      suitabilityOfContactPerson: [
        '',
        [Validators.maxLength(2000)],
      ],

      // Part C: faculty evaluator for Level B hackathon submissions (optional)
      facultyEvaluatorDetails: ['', [Validators.maxLength(2000)]],

      // Part C: alternate operational coordinator details (optional)
      alternativeCoordinatorDetails: ['', [Validators.maxLength(2000)]],

      // Part C: preferred month/fortnight to host the workshop
      preferredWorkshopTimeline: [
        '',
        [Validators.maxLength(300)],
      ],

      alternateSPOCFullName: [''],
      alternateSPOCName: [''],

      alternateSPOCEmail: [
        '',
        Validators.email,
      ],

      alternateSPOCDesignation: [''],

      alternateSPOCPhone: [
        '',
        Validators.pattern('^[0-9]{10}$'),
      ],

      studentConveningMechanisms: [
        '',
        Validators.maxLength(2000),
      ],

      preferredAvailabilityFrom: [
        '',
        Validators.required,
      ],

      preferredAvailabilityTo: [
        '',
        Validators.required,
      ],

      eventAlignmentNote: [''],

      expectedStudentParticipants: [
        '',
        Validators.required,
      ],

      additionalInformation: ['', Validators.maxLength(2000)],
    });
  }


  ngOnInit() {

    this.registrationWindowStatus = getRegistrationWindowStatus();
    this.registrationWindowMessage = getRegistrationWindowMessage(
      this.registrationWindowStatus,
    );
    this.subscribeToLanguageChange();
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.minFromDate = today;

    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.minToDate = tomorrow;
    if (!isPlatformServer(this.platformId)) {

      this.getUserProfile();
    }
    this.trackDateChanges();
  }
  isInvalid(controlName: string): boolean {
    const control = this.applicationForm.get(controlName);
    return !!(control && control.invalid && control.touched);
  }
  getUserProfile() {
    const loggedInUser = this.cachingService.fetchUserInfo();
    if (loggedInUser) {
      this.cachingService?.loggedInUser.next(loggedInUser);
      this.cachingService?.loggedInUser
        .pipe(
          take(1),
          tap(({ token }) => {
            this.userToken = token;
          }),
        )
        .subscribe();
    }
    this.cachingService?.loggedInUser.subscribe((data) => {
      const user = data?.user;
      this.userProfile = user;
      this.cachingService.userId = user?.id;

      this.isAuthResolved = true;
    });
  }
  trackDateChanges() {
    this.applicationForm.get('preferredAvailabilityFrom')?.valueChanges.subscribe(fromDateVal => {
      if (fromDateVal) {
        const fromDate = new Date(fromDateVal);

        const nextDay = new Date(fromDate);
        nextDay.setDate(nextDay.getDate() + 1);
        this.minToDate = nextDay;

        const toControl = this.applicationForm.get('preferredAvailabilityTo');
        if (toControl) {
          const currentToValue = toControl.value;
          if (!currentToValue || new Date(currentToValue) <= fromDate) {
            toControl.setValue(nextDay);
          }
        }
      }
    });
  }


  getLength(controlName: string): number {
    return (
      this.applicationForm.get(controlName)?.value?.length || 0
    );
  }
  onSectorChange(sector: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const currentSectors = this.applicationForm.get('relevantSectors')?.value || [];

    if (checked) {
      this.applicationForm.get('relevantSectors')?.setValue([...currentSectors, sector]);
    } else {
      this.applicationForm.get('relevantSectors')?.setValue(
        currentSectors.filter((s: string) => s !== sector)
      );
    }

    this.applicationForm.get('relevantSectors')?.markAsTouched();

    if (sector === 'Others') {
      const otherDetailsControl = this.applicationForm.get('otherSectorDetails');
      if (otherDetailsControl) {
        if (checked) {
          otherDetailsControl.setValidators([Validators.required]);
        } else {
          otherDetailsControl.clearValidators();
          otherDetailsControl.setValue('');
        }
        otherDetailsControl.updateValueAndValidity();
      }
    }
  }

  isSectorSelected(sector: string): boolean {
    const sectors = this.applicationForm.get('relevantSectors')?.value || [];
    // Checks both raw "Others" and formatted "Others: text" variants
    return sectors.some((s: string) => s === sector || s.startsWith(sector + ':'));
  }

  getFormattedPayload() {
    const rawValues = this.applicationForm.value;
    const sectorsList = rawValues.relevantSectors || [];
    const otherValue = rawValues.otherSectorDetails || '';

    const formattedSectors = sectorsList.map((sector: string) => {
      // Strips any existing prefix to prevent compounding "Others: Others: text" bugs
      const cleanSector = sector.startsWith('Others') ? 'Others' : sector;

      if (cleanSector === 'Others' && otherValue) {
        return `Others: ${otherValue}`;
      }
      return cleanSector;
    });

    return {
      ...rawValues,
      relevantSectors: formattedSectors
    };
  }

  scrollToFirstError(): void {
    setTimeout(() => {
      const element = document.querySelector(
        '.input-error, .checkbox-error'
      );

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }, 100);
  }

  onSubmit(): void {
    if (this.applicationForm.invalid) {
      this.applicationForm.markAllAsTouched();
      this.scrollToFirstError();
      return;
    }


    const formId = 'TTuA1XpS';

    const formData = {
      userid: this.userProfile?.id || null,
      step: 1,
      ...this.applicationForm.value,
    };
    const parts = formData.officialEmailAddress.split('@');
    this.loaderService.show();
    this.apiService
      .registerWorkshop(formId, formData)
      .subscribe({
        next: (res: any) => {
          this.loaderService.hide();
          if (res?.header?.error || res?.header?.success === false) {
            // this.toasterService.error(
            //   `An application already exists for the provided official email address.`
            // );
            this.toasterService.error(res?.header?.msg)
            return;
          }

          this.toasterService.success(
            'Form submitted successfully!'
          );

          this.generatedReferenceId = res?.data?.id
            ? `${formId}-${res.data.id}`
            : formId;

          this.submittedUserEmail =
            parts.length === 2
              ? parts[0].substring(0, 4) + '****@' + parts[1]
              : formData.officialEmailAddress;

          this.showSuccessPopup = true;

          this.applicationForm.reset();
        },
        error:(error)=>{
      this.loaderService.hide();
        }
      });
  }

  handleModalClose(): void {
    this.showSuccessPopup = false;
    this.router.navigate([routes.home]);
  }

  resetForm(): void {
    this.applicationForm.reset();
    this.applicationForm
      .get('relevantSectors')
      ?.setValue([]);
  }
  private subscribeToLanguageChange(): void {
    this.cachingService.languageChange$
      .pipe(
        skip(1),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.refreshAppContent();
      });
  }
  private refreshAppContent(): void {
    this.renderRegisterFormContent = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.renderRegisterFormContent = true;
      this.cdr.detectChanges();
    });
  }
}
